
import styled from "styled-components"
import PageTopTitle from "../../shared/PageTopTitle"
import { useSelector } from "react-redux"
import { showNestedModal } from "../../../features/modal/modalSlice"
import { useDispatch } from "react-redux"
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useEffect, useState } from "react"
import { MdDragIndicator } from "react-icons/md";
import Btn from "../../shared/button/Btn"
import { updateAiSubTitleOrder } from "../../../features/aiControl/aiControlSlice"
import SmallSpinner from "../../shared/spinners/SmallSpinner"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        max-height: 600px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            width: 100%;
            padding: 30px;
            padding-top: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow: auto;

            p{
                padding-bottom: 20px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }

        }

        .btn-container{
            width: 100%;
            background-color: ${({theme}) => theme.mainBgColor};
            display: flex;
            height: 90px;
            justify-content: center;
            align-items: center;
            gap: 25px;
            border-top: 1px solid ${({theme}) => theme.mainBorderColor};
            padding: 15px 0;

        }
    }
`

const ContentContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .list-item{
        width: 100%;
        display: flex;
        align-items: center;
        padding: 20px;
        border-radius: 10px;
        background-color: ${({theme}) => theme.secondaryBgColor};

        .drag-icon{
            font-size: 1.4rem;
        }

        .title-name{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
        }
    }

`


const UpdateAiSubTitleOrderModal = () => {

    const {aiSubTitleData, isLoadingUpdateAiSubTitleOrder} = useSelector(state => state.aiControl)

    const dispatch = useDispatch()

    const [list, setList] = useState([])
    
    useEffect(() => {
        setList(aiSubTitleData.map(item => {
            return {...item, subTitleId: item.subTitleId.toString()}
        }))
    },[])

    
    const onDragEnd = (result) => {
        if (!result.destination) return; // Sürükleme hedefi yoksa
        const reorderedItems = Array.from(list);
        const [movedItem] = reorderedItems.splice(result.source.index, 1); // Öğeyi kaydır
        reorderedItems.splice(result.destination.index, 0, movedItem);
    

        const orderedList = reorderedItems.map((item, i) => {
            return {
                ...item, subTitleOrder: i+1
            }
        })

        setList(orderedList)
      };


      const handleSubmit = () => {
        const orderList = list.map(item => {
            return {
                subTitleId:parseInt(item.subTitleId),
                subTitleOrder: item.subTitleOrder
            }
        })
        dispatch(updateAiSubTitleOrder(orderList))
      }

  return (
    <Container onClick={() => dispatch(showNestedModal(null))}>
        <div className="modal" onClick={e => e.stopPropagation()}>
            <PageTopTitle title={"Alt Başlıkları Sırala"}/>
            <div className="content">
                <p>{list.length > 0 ? "Alt Başlıkları sürükle bırak yöntemi ile sıralayabilirsiniz." : "Henüz hiç alt başlık eklenmemiş."} </p>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="ddd">
                        {(provided) => (
                        <ContentContainer {...provided.droppableProps} ref={provided.innerRef}>
                            {list?.map((item, index) => (
                            <Draggable key={item.subTitleId} draggableId={item.subTitleId} index={index}>
                                {(provided) => (
                                <div
                                className='list-item'
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    ref={provided.innerRef}
                                >
                                    <MdDragIndicator className="drag-icon"/>
                                    <div className="title-name">{index+1}. {item.subTitleName}</div>
                                </div>
                                )}
                            </Draggable>
                            ))}
                        </ContentContainer>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
            <div className="btn-container">
                <Btn handleClick={handleSubmit} color="#fff" width={"200px"} height="44px" bgColor="#E85546" >{isLoadingUpdateAiSubTitleOrder ? <SmallSpinner size={"22px"} color={"#fff"} bgColor={"#E85446"}/> : "Kaydet"}</Btn>
                <Btn handleClick={()=> dispatch(showNestedModal(null))} color="#E85546" width={"200px"} height="44px" >{list.length > 0 ? "Vazgeç" : "Geri Dön"}</Btn>
            </div>
        </div>
    </Container>
  )
}

export default UpdateAiSubTitleOrderModal